import React from 'react';
import { CountdownBanner } from './components/CountdownBanner';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ContentSection } from './components/ContentSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { CTAButton } from './components/CTAButton';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-[#0A0A0A] font-sans" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <CountdownBanner data-id="element-2" />

      <main className="pt-10 md:pt-12" data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />

        {/* Extra Persuasive CTA between Problem and Solution */}
        <section className="py-6 bg-[#111827] text-center px-4 border-t border-gray-800" data-id="element-6">
          <div className="max-w-3xl mx-auto" data-id="element-7">
            <CTAButton text="🚀 QUIERO TRANSFORMAR MI TIEMPO EN CONOCIMIENTO" data-id="element-8" />
          </div>
        </section>

        <SolutionSection data-id="element-9" />
        <ContentSection data-id="element-10" />
        <BeforeAfterSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <BonusSection data-id="element-13" />
        <PricingSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <SocialProofPopup data-id="element-17" />
    </div>;
}